import { BoundNumberField, BoundNumberFieldProps, useComputed } from "@homebound/beam";
import { ObjectState } from "src/utils/formState";
import { AiProposalValue } from "./AiProposalValue";
import { AiFieldProposalFormValue } from "./utils/aiFieldProposalForm";
import { parseAiNumber, pendingProposedValue, resolveAiProposalStatus } from "./utils/bindAiProposal";

// Derive proposedValue from aiProposal so callers cannot supply a conflicting value.
export type BoundAiNumberFieldProps = Omit<BoundNumberFieldProps, "proposedValue"> & {
  aiProposal?: ObjectState<AiFieldProposalFormValue>;
};

export function BoundAiNumberField(props: BoundAiNumberFieldProps) {
  const { field, aiProposal, onChange, ...others } = props;
  // Track proposal status and fieldValue so the pending proposal stays in sync.
  const proposedValue = useComputed(() => pendingProposedValue(aiProposal, parseAiNumber), [aiProposal]);
  const originalValue = useComputed(() => field.originalValue, [field]);
  return (
    <AiProposalValue aiProposal={aiProposal} originalValue={originalValue}>
      <BoundNumberField
        field={field}
        proposedValue={proposedValue}
        onChange={(value) => {
          field.set(value);
          resolveAiProposalStatus(aiProposal, parseAiNumber, value);
          onChange?.(value);
        }}
        {...others}
      />
    </AiProposalValue>
  );
}
